
export const ActionButtonGroup = ({ children }) => {
    
    return (
        <div className="max-width-action-button-group">
            {children}
        </div>
    )
}
